import classNames from 'classnames';
import { useState } from 'react';
import styles from './index.module.scss';
import EFArrowDown from '@/efelement/EFIcon/EFArrowDown';

interface EFMenuParams {
    children?: React.ReactNode;
    className?: string;
    data?: any;
    theme?: string | undefined;
    onClick?: any;
}

const EFMenu = ({ className = '', data = [], theme = 'light', onClick, children, ...rest }: EFMenuParams) => {
    const prefixCls = 'ef-menu';
    const _key = 'key';
    const _label = 'label';
    const classString = classNames(prefixCls, styles.efmenu, className, {
        [`${prefixCls}-dark`]: theme === 'dark',
    });
    const [selList, setSelList] = useState<any>([]);
    const [selKey, setSelKey] = useState('');

    const toggleHandle = (item: any, index: number) => {
        if (item && item.children) {
            const listA = JSON.parse(JSON.stringify(selList));
            const pos = listA.indexOf(index);
            if (pos > -1) {
                //有
                listA.splice(pos, 1);
            } else {
                //无
                listA.push(index);
            }
            setSelList(listA);
        } else {
            selectHandle(item);
        }
    };

    const selectHandle = (item: any) => {
        setSelKey(item[_key]);
        onClick &&
            onClick({
                item: item,
                key: item[_key],
            });
    };

    return (
        <ul className={classString} {...rest}>
            {data.map((item1: any, index1: number) => {
                return (
                    <li
                        key={index1}
                        className={`${prefixCls}-item${!!item1.children ? ` ${prefixCls}-item-hadchild` : ` ${prefixCls}-item-nonechild`}${
                            selList.includes(index1) ? ` ${prefixCls}-item-open` : ''
                        }${selKey === item1[_key] ? ` ${prefixCls}-active` : ''}`}
                        onClick={() => toggleHandle(item1, index1)}
                    >
                        <div className={`${prefixCls}-title`}>
                            {item1[_label]}
                            <EFArrowDown />
                        </div>
                        <ul className={`${prefixCls}-sub`}>
                            {item1.children &&
                                item1.children.map((item2: any, index2: number) => (
                                    <li
                                        key={index2}
                                        className={`${prefixCls}-sub-item${selKey === item2[_key] ? ` ${prefixCls}-active` : ''}`}
                                        onClick={(e: any) => {
                                            e.stopPropagation();
                                            selectHandle(item2);
                                        }}
                                    >
                                        {item2[_label]}
                                    </li>
                                ))}
                        </ul>
                    </li>
                );
            })}
        </ul>
    );
};

export default EFMenu;
